import { IconBrain, IconChevronDown } from '@tabler/icons-react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  SvgIcon,
  Typography,
} from '@mui/material'
import type { Message } from '../api'
import { MarkdownContent } from './MarkdownContent'
import { ToolCallBlock } from './ToolCallBlock'

type Props = {
  message: Message
}

export const MessageBubble = ({ message }: Props) => {
  const isUser = message.role === 'user'
  console.log('message.toolCalls', message.toolCalls)
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        mb: 1.5,
      }}
    >
      <Box sx={{ maxWidth: '85%', minWidth: 60 }}>
        {/* Reasoning block */}
        {message.reasoning && (
          <Accordion
            disableGutters
            elevation={0}
            sx={{
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              bgcolor: 'transparent',
              '&:before': { display: 'none' },
            }}
          >
            <AccordionSummary
              expandIcon={
                <SvgIcon sx={{ fontSize: 16 }}>
                  <IconChevronDown />
                </SvgIcon>
              }
              sx={{ minHeight: 32, py: 0, px: 1.5 }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <SvgIcon sx={{ fontSize: 16, color: 'text.secondary' }}>
                  <IconBrain />
                </SvgIcon>
                <Typography variant="caption" color="text.secondary">
                  Thinking
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 1.5, pb: 1.5, pt: 0 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}
              >
                {message.reasoning}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )}

        {/* Tool calls */}
        {message.toolCalls.length > 0 && (
          <Box sx={{ mb: 1 }}>
            {message.toolCalls.map((tc) => (
              <ToolCallBlock key={tc.toolCallId} toolCall={tc} />
            ))}
          </Box>
        )}

        {/* Message content */}
        {(message.content || message.isStreaming) && (
          <Box
            sx={{
              px: 1.5,
              py: 1,
              borderRadius: 2,
              bgcolor: isUser ? 'primary.main' : 'action.hover',
              color: isUser ? 'primary.contrastText' : 'text.primary',
            }}
          >
            {isUser ? (
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                {message.content}
              </Typography>
            ) : (
              <MarkdownContent content={message.content} />
            )}
            {message.isStreaming && (
              <Box
                component="span"
                sx={{
                  display: 'inline-block',
                  width: 8,
                  height: 14,
                  ml: 0.25,
                  bgcolor: 'currentColor',
                  animation: 'blink 1s step-end infinite',
                  verticalAlign: 'text-bottom',
                  '@keyframes blink': {
                    '0%, 100%': { opacity: 1 },
                    '50%': { opacity: 0 },
                  },
                }}
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}
